import doLog from '@/common/log';
import React from 'react';
import classNames from 'classnames';
import Collapsible from '@/common/collapsible';
import './index.less';
interface PropType {
  productLightCustomizationList: CustomizationTypes.Root[];
  lightCustomModel: string;
  i18n: DetailTypes.i18n;
  customModel: string;
  abtest: DetailTypes.Abtest;
}

export default function Index(props: PropType) {
  const { productLightCustomizationList = [], lightCustomModel, customModel, i18n, abtest } = props;
  const isCustom = lightCustomModel || customModel;

  const renderCustom = () => {
    if (isCustom) {
      return (
        <div className="customize">
          <h4>{i18n['detail_pc_oline_customization']} </h4>
          <div
            id="product-custom"
            onClick={() => {
              doLog('/sc.details.customOnline');
            }}
          ></div>
        </div>
      );
    } else {
      return null;
    }
  };

  if (isCustom || productLightCustomizationList.length > 0) {
    return (
      <div className="customization-layout">
        <Collapsible
          title={i18n['marketAction.customize']?.replace(':', '')}
          abtest={abtest}
          logInfo="customization"
        >
          <>
            {renderCustom()}
            {isCustom && <h4>{i18n['detail_pc_other_customiaztion_options']}</h4>}
            <div
              className={classNames({
                'customization-info': true,
              })}
            >
              <div className="customization-list">
                {productLightCustomizationList.map((item) => (
                  <div className="customization-item">
                    <div className="title">{item.customType}</div>
                    <div className="info">
                      {i18n['marketAction.moqName']}: {item.moq}
                    </div>
                  </div>
                ))}
              </div>
              <div className="customization-link">
                <span>{i18n['detail_pc_for_more_customization_details']} </span>{' '}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    doLog('/sc.details.customMessageSupplier');
                    (
                      document.querySelector(
                        '[data-type-btn="chat"],[data-type-btn="message"],[data-type-btn="inquiry"]',
                      ) as HTMLElement
                    )?.click();
                  }}
                >
                  {i18n['detail_pc_custom_floor_ACT_2']}
                </a>
              </div>
            </div>
          </>
        </Collapsible>
      </div>
    );
  } else {
    return null;
  }
}
